import { COUNTRY_NAMES } from '@constants/countries';
import { LocationIntegrationStatus } from '@constants/companies';
import { LocationIntegrationName } from '@constants/integrations';

// Keep in sync with server ListingDirectoriesCountries.SupportedCountryCodes.
export const DIRECTORIES_SUPPORTED_COUNTRIES = ['US', 'BR', 'GB', 'ES', 'PT', 'UA', 'MX', 'CA'];

const nameToCode = Object.entries(COUNTRY_NAMES).reduce((acc, [code, name]) => {
    acc[name.toLowerCase()] = code;
    return acc;
}, {});

const resolveIso2 = country => {
    if (!country) {
        return null;
    }
    const trimmed = String(country).trim();
    if (!trimmed) {
        return null;
    }
    if (trimmed.length === 2) {
        return trimmed.toUpperCase();
    }
    return nameToCode[trimmed.toLowerCase()] ?? null;
};

// Fails open: unrecognized country strings defer to the authoritative backend gate rather than
// hiding a location the server would allow.
export const isDirectoriesCountrySupported = country => {
    const code = resolveIso2(country);
    if (!code) {
        return true;
    }
    return DIRECTORIES_SUPPORTED_COUNTRIES.includes(code);
};

export const isDirectoryPlatformId = platform => typeof platform === 'string';

export const isLocationListed = location =>
    (location?.integrations ?? []).some(
        item =>
            item.type === LocationIntegrationName.ListingDirectories &&
            (item.status === LocationIntegrationStatus.Connected || item.status === LocationIntegrationStatus.Pending),
    );
